export const USERS = {
  BETA_TESTERS: [
    "zech.campbell@gmail.com",
    "satoruy9@gmail.com",
    "lisafong4@gmail.com",
    "astrid.s.rivera20@gmail.com",
    "m.galvan@mac.com",
    "matt.dac@gmail.com"
  ]
};
